import { APP_ZONES, GridPosition, WorkflowWidgetConfig } from '@finxone-platform/shared/sys-config-types';
import { QuickLinkWidgetBuilder, TextWidgetBuilder } from '../../widgets/example-builder';

export function generateTextWidget(override: {
  text: string;
  position: GridPosition;
  displayName: string;
  styles: any;
  isRemovable: boolean;
}): WorkflowWidgetConfig {
  return new TextWidgetBuilder()
    .text(override?.text)
    .gridPosition(override?.position)
    .configDisplayName(override?.displayName)
    .cssConfig(override?.styles)
    .isRemovable(override?.isRemovable)
    .build();
}

export function getQuickLinkWidget(override: {
  text: string;
  position: GridPosition;
  pageUrl: string;
  displayName: string;
  styles: any;
  zone: string;
  isRemovable?: boolean;
  icon?: string;
  globalStyling?: boolean;
  globalStylingClass?: string;
}): WorkflowWidgetConfig {
  return new QuickLinkWidgetBuilder()
    .zone(override?.zone)
    .navigateToPageUrl(override?.pageUrl)
    .navigationOption('use-as-navigation')
    .role()
    .text(override?.text)
    .configDisplayName(override?.displayName)
    .cssConfig(override?.styles)
    .gridPosition(override?.position)
    .isRemovable(override?.isRemovable || false)
    .setWidgetProperties({
      textContent: override?.text,
      icon: override?.icon ?? '',
    })
    .setGlobalStylingClass(override?.globalStyling, override?.globalStylingClass)
    .build();
}

export function bulkPaymentFooter(y: number) {
  return [
    getQuickLinkWidget({
      text: 'Privacy Policy',
      position: { x: 1, y: y, rows: 1, cols: 5 } as GridPosition,
      pageUrl: 'privacy-policy',
      displayName: 'Quick Link: Privacy Policy',
      styles: {
        justifyContent: 'center',
        textAlignment: 'center',
        fontSize: 16,
        lineHeight: '24',
        textFont: 'var(--font-family)',
        color: 'var(--color-on-background-muted)',
      },
      zone: APP_ZONES.PROFILE,
      isRemovable: true,
    }),

    getQuickLinkWidget({
      text: 'FAQs',
      position: { x: 6, y: y, rows: 1, cols: 3 } as GridPosition,
      pageUrl: 'faqs-landing',
      displayName: 'Quick Link: FAQs',
      styles: {
        justifyContent: 'center',
        textAlignment: 'center',
        fontSize: 16,
        lineHeight: '24',
        textFont: 'var(--font-family)',
        color: 'var(--color-on-background-muted)',
      },
      zone: APP_ZONES.PROFILE,
      isRemovable: true,
    }),
  ];
}
